import ParseError from "./ParseError.mjs";
class ParserError extends ParseError {}
export default ParserError;